import {logError} from '../../../common/error.js'
import parseHash from '../../../common/parseHash.js'

export const BASE = 'ordoro/ui'
export const SET_LOCATION = `${BASE}/SET_LOCATION`
export const SET_CURRENT_PAGE = `${BASE}/SET_CURRENT_PAGE`
export const SET_GLOBAL_ERROR = `${BASE}/SET_GLOBAL_ERROR`
export const SET_NOTIFICATION = `${BASE}/SET_NOTIFICATION`
export const OPEN_MODAL = `${BASE}/OPEN_MODAL`
export const CLOSE_MODAL = `${BASE}/CLOSE_MODAL`
export const APPLY_LOCATION_HREF = `${BASE}/APPLY_LOCATION_HREF`
export const SET_API_LOCKED_LATCH = `${BASE}/SET_API_LOCKED_LATCH`
export const SET_ZUCK_COMPANY_ID = `${BASE}/SET_ZUCK_COMPANY_ID`
export const SET_ZUCK_SUPPRESS_APP_MESSAGE = `${BASE}/SET_ZUCK_SUPPRESS_APP_MESSAGE`

export function navigate(url) {
  console.warn('DEPRECATED WARNING: navigate(url) called.')

  return {
    type: APPLY_LOCATION_HREF,
    payload: url,
  }
}

export function setLocation(url) {
  return {
    type: SET_LOCATION,
    payload: parseHash(url),
  }
}

export function setGlobalError(errorMessage, error) {
  if (errorMessage) {
    logError(error, errorMessage)
  }

  // TODO: add more generic server messaging here
  // if (error.message === 'Error contacting the server') {
  // }

  // if ([502, 504].includes(get(error, 'response.status'))) {

  // }

  return {
    type: SET_GLOBAL_ERROR,
    payload: errorMessage,
  }
}

export function setCurrentPage(payload) {
  return {
    type: SET_CURRENT_PAGE,
    payload,
  }
}

export function openModal(modal, meta = {}) {
  const action = {
    type: OPEN_MODAL,
    payload: {
      modalName: modal.modalName || modal,
      meta,
    },
  }

  return action
}

export function closeModal(meta = {}) {
  return {
    type: CLOSE_MODAL,
    payload: {meta},
  }
}

export function setAPILockedLatch(apiLockedLatch) {
  return {
    type: SET_API_LOCKED_LATCH,
    payload: apiLockedLatch,
  }
}

export function setZuckCompanyID(zuckCompanyID) {
  return {
    type: SET_ZUCK_COMPANY_ID,
    payload: zuckCompanyID,
  }
}

export function setZuckSuppressAppMessage(zuckSuppressAppMessage) {
  return {
    type: SET_ZUCK_SUPPRESS_APP_MESSAGE,
    payload: zuckSuppressAppMessage,
  }
}
